
	import useDoctor from "@/store/DoctorState";
	import usePatientHelper from "@/store/PatientHelperState";
	import { defineComponent, ref } from "vue";
	import { onBeforeRouteLeave } from "vue-router";
	import PatientInfoSheet from "@/components/PatientInfoSheet.vue";
	import PatientMeasurementsSheet from "@/components/PatientMeasurementsSheet.vue";
	import PatientNotesSheet from "@/components/PatientNotesSheet.vue";
	import PatientDiariesSheet from "@/components/PatientDiariesSheet.vue";
	import NavBar from "@/components/NavBar.vue";

	enum SheetView {
		PatientInfo,
		PatientMeasurements,
		PatientNotes,
		PatientDiaries,
	}
	export default defineComponent({
		name: "patient-card",
		components: {
			PatientInfoSheet,
			PatientMeasurementsSheet,
			PatientNotesSheet,
			PatientDiariesSheet,
			NavBar,
		},
		setup() {
			const { patientSelected, listenOnPatientDataChange } = useDoctor();
			const { fetchLikertRecords, likertRecords, fetchDoctorNotes, doctorNotes } = usePatientHelper();
			

			fetchDoctorNotes(patientSelected.value!.id)
			fetchLikertRecords(patientSelected.value!.id)
			let closeOnPatientDataChange = listenOnPatientDataChange(
				patientSelected.value!.id
			);
			onBeforeRouteLeave((_, __, next) => {
				closeOnPatientDataChange();
				next();
			});

			const activeSheetView = ref<SheetView>(SheetView.PatientInfo);

			return { patient: patientSelected, activeSheetView, SheetView, likertRecords, doctorNotes };
		},
	});
